import { BaseEntity } from '../base/BaseEntity';

export class AttributeReference extends BaseEntity {
    name: string;
    filter: string;
    apiPath: string;
}
